"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _settings = require("@/settings");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'consumeOrder',
  components: {},
  emits: ['addAct'],
  data: function data() {
    return {
      activeIndex2: '1',
      shops: [{
        id: 1,
        name: '机构1'
      }, {
        id: 2,
        name: '机构2'
      }, {
        id: 3,
        name: '机构3'
      }, {
        id: 4,
        name: '机构4'
      }, {
        id: 5,
        name: '机构5'
      }],
      memberLvs: [{
        id: 1,
        lvname: '普卡'
      }, {
        id: 2,
        lvname: '银卡'
      }, {
        id: 3,
        lvname: '金卡'
      }, {
        id: 4,
        lvname: '黑金卡'
      }, {
        id: 5,
        lvname: '钻石卡'
      }],
      loading: false,
      activeTab: 'wxOrder',
      searchForm: {
        orderId: '',
        shopId: '',
        memberLv: '',
        isAuth: '',
        type: '',
        page: 1,
        limit: 10,
        total: 0,
        times: ''
      },
      tableData: [{
        id: 1,
        title: '活动名称',
        couponBame: '饮品五折券',
        shareCouponName: '整单85折',
        extraReward: '50积分',
        actTime: '2020-12-01 10:10:10-2020-12-31 23:59:59',
        totalNum: '1000',
        expanding: '500',
        expandComplete: '400',
        expandFail: '100',
        actStatus: '未启用',
        registerNum: '200'
      }, {
        id: 2,
        title: '活动名称',
        couponBame: '饮品五折券',
        shareCouponName: '整单85折',
        extraReward: '50积分',
        actTime: '2020-12-01 10:10:10-2020-12-31 23:59:59',
        totalNum: '1000',
        expanding: '500',
        expandComplete: '400',
        expandFail: '100',
        actStatus: '启用',
        registerNum: '200'
      }],
      showAddDialog: false,
      addForm: {
        title: '',
        couponBame: '',
        shareCouponName: '',
        extraReward: '',
        actTime: ''
      },
      addFormRules: {
        title: [{
          required: true,
          message: '请输入奖励内容',
          trigger: 'blur'
        }],
        couponBame: [{
          required: true,
          message: '请输入参与活动',
          trigger: 'blur'
        }],
        shareCouponName: [{
          required: true,
          message: '请输入满足次数',
          trigger: 'blur'
        }],
        extraReward: [{
          required: true,
          message: '请输入奖励',
          trigger: 'blur'
        }],
        actTime: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    addAct: function addAct() {
      this.showAddDialog = true;
    },
    handleViewDetail: function handleViewDetail() {
      this.$emit('viewDetail');
    },
    changeTime: function changeTime(e) {
      console.log(e);
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.searchForm.sortField = prop;
      this.searchForm.sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : '';
      this.fetchList();
    },
    handleTabChange: function handleTabChange(tab) {
      this.activeTab = tab.name;
    },
    fetchList: function fetchList() {
      var _this = this;
      this.loading = tr;
      getTaskueList(this.searchForm).then(function (res) {
        // this.tableData = res.records || []
        _this.searchForm.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    resetForm: function resetForm() {
      this.searchForm = {
        orderId: '',
        shopId: '',
        memberLv: '',
        isAuth: '',
        type: '',
        page: 1,
        limit: 10,
        total: 0,
        times: ''
      }, this.fetchList();
    },
    download: function download() {},
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    submitAddForm: function submitAddForm() {
      var _this2 = this;
      this.$refs.addFormRef.validate(function (valid) {
        if (valid) {
          // 提交表单
          console.log('提交的表单数据:', _this2.addForm);
          _this2.showAddDialog = false;
        } else {
          console.log('表单验证失败');
        }
      });
    }
  },
  mounted: function mounted() {
    this.fetchList();
  }
};